import React from 'react';
import {useIntl} from 'react-intl';

import {useCustomerMgr} from 'coreHooks';

import FlyoutToggleButton from 'brandComponents/flyouts/FlyoutToggleButton';
import Icon from 'brandComponents/Icon';
import Link from 'brandComponents/Link';

import messages from './messages';

const MyAccountServiceMenuItem = () => {
	const intl = useIntl();
	const CustomerMgr = useCustomerMgr();
	const customer = CustomerMgr.getCurrentCustomer();

	return (
		<>
			<FlyoutToggleButton
				isDisabled={customer.isRegistered}
				flyoutId={!customer?.isRegistered && 'login'}
				buttonContent={
					customer?.isRegistered ? (
						<Link to="/myaccount">
							<Icon
								name="account-regular-fill"
								title={intl.formatMessage(messages.myAccount)}
								height={20}
								width={20}
							/>
						</Link>
					) : (
						<Icon
							name="account-regular"
							title={intl.formatMessage(messages.logIn)}
							height={20}
							width={20}
						/>
					)
				}
			/>
		</>
	);
};

export default MyAccountServiceMenuItem;
